export default{
    ua_no_spend_ua:'UA',
    ua_no_spend_Install:'安装',
    ua_no_spend_Register:'注册',
    ua_no_spend_avgd2:'平均次留',
    ua_no_spend_avgd3:'平均3留',
    ua_no_spend_avgd7:'平均7留',
    ua_no_spend_engagementTrends:'活跃指标',
    ua_no_spend_D2:'次留',
    ua_no_spend_d2:'次留',
    ua_no_spend_D3:'3留',
    ua_no_spend_D7:'7留',
    ua_no_spend_d3:'3留',
    ua_no_spend_d7:'7留',
    ua_no_spend_chart_Organic:'自然用户',
    ua_no_spend_chart_Others:'其他',
    ua_no_spend_chart_ua:'UA',


    // table
    ua_no_spend_D14:'14留',
    ua_no_spend_D30:'30留',
    ua_no_spend_LTV1:'一天LTV',
    ua_no_spend_LTV3:'三天LTV',
    ua_no_spend_LTV7:'七天LTV',
    ua_no_spend_LTV14:'14天LTV',
    ua_no_spend_LTV30:'30天LTV',
    ua_no_spend_LTV180:'180天LTV',

    ua_no_spend_Country_Region_Network_TypeBreakdown:'国家/区域/网络类型 排行榜',
    ua_no_spend_Top_Country:'新进用户 Top 10 国家',
    ua_no_spend_Top_Region:'新进用户 Top 10 区域',
    ua_no_spend_Top_Network:'新进用户 Top 10 网络类型',

    ua_no_spend_Ltv7_Top_Country:'七天LTV Top 10 国家',
    ua_no_spend_Ltv7_Top_Region:'七天LTV Top 10 区域',
    ua_no_spend_Ltv7_Top_Network:'七天LTV Top 10 网络类型',

}
